import * as React from 'react';

const HomePageArrow = ({
  fill = '#4A4F4A',
  width = 22,
  height = 16,
}: React.SVGProps<SVGSVGElement>) => (
<svg width={width} height={height} viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.8335 8.93338H1.3335C1.04461 8.93338 0.805718 8.83894 0.616829 8.65005C0.427941 8.46116 0.333496 8.22227 0.333496 7.93338C0.333496 7.64449 0.427941 7.4056 0.616829 7.21672C0.805718 7.02783 1.04461 6.93338 1.3335 6.93338H17.8335L12.9002 2.00005C12.7002 1.80005 12.6057 1.56672 12.6168 1.30005C12.6279 1.03338 12.7335 0.800049 12.9335 0.600049C13.1335 0.400049 13.3668 0.300049 13.6335 0.300049C13.9002 0.300049 14.1335 0.400049 14.3335 0.600049L20.9668 7.23338C21.0779 7.34449 21.1557 7.4556 21.2002 7.56672C21.2446 7.67783 21.2668 7.80005 21.2668 7.93338C21.2668 8.06672 21.2446 8.18894 21.2002 8.30005C21.1557 8.41116 21.0779 8.52227 20.9668 8.63338L14.3668 15.2334C14.1668 15.4334 13.9335 15.5334 13.6668 15.5334C13.4002 15.5334 13.1668 15.4334 12.9668 15.2334C12.7668 15.0334 12.6668 14.7945 12.6668 14.5167C12.6668 14.2389 12.7668 14 12.9668 13.8L17.8335 8.93338Z" fill={fill}/>
</svg>

);

export default HomePageArrow;
